const ACTIVE_TRIGGER_CLASSES = ['underline', 'font-semibold'];
const INACTIVE_TRIGGER_CLASSES = ['no-underline', 'font-normal'];

class CollectionTabTabs extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.triggers = [...this.querySelectorAll('[data-collection-tab-trigger]')];
    this.panels = [...this.querySelectorAll('[data-collection-tab-panel]')];

    if (this.triggers.length < 2) return;

    this.initialized = true;
    this.controller = new AbortController();
    const { signal } = this.controller;

    for (const trigger of this.triggers) {
      trigger.addEventListener('click', () => this.activate(trigger.dataset.tabTarget), { signal });
    }

    document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.initialized = false;
  }

  onBlockSelect(event) {
    const { blockId } = event.detail;
    const isOwnTrigger = this.triggers.some((trigger) => trigger.dataset.tabTarget === blockId);
    if (!isOwnTrigger) return;

    this.activate(blockId);
  }

  activate(targetId) {
    for (const trigger of this.triggers) {
      const isTarget = trigger.dataset.tabTarget === targetId;
      trigger.setAttribute('aria-selected', String(isTarget));
      trigger.classList.remove(...(isTarget ? INACTIVE_TRIGGER_CLASSES : ACTIVE_TRIGGER_CLASSES));
      trigger.classList.add(...(isTarget ? ACTIVE_TRIGGER_CLASSES : INACTIVE_TRIGGER_CLASSES));
    }

    for (const panel of this.panels) {
      panel.hidden = panel.id !== targetId;
    }

    // Embla measures its viewport on init. Every panel but the first is
    // display:none at page load, so those carousels come up at zero width and
    // stay broken until the panel is visible and they are told to measure again.
    const shown = this.panels.find((panel) => panel.id === targetId);
    for (const carousel of shown?.querySelectorAll('carousel-track') ?? []) {
      carousel.reInit?.();
    }
  }
}

if (!customElements.get('collection-tab-tabs')) {
  customElements.define('collection-tab-tabs', CollectionTabTabs);
}
